import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7728accc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pw_result" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "비밀번호 변경이 완료되었습니다.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loginPageMove()))
    }, "로그인 하기")
  ]))
}